import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function postAirroadJobsDownloadLabelsFile(
  params: openapi.AirroadDownloadLabelsQueryOpenapi,
  data: openapi.AirroadDownloadLabelsBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AirroadDownloadLabelsContentOpenapi> {
  return await api.post<openapi.AirroadDownloadLabelsContentOpenapi>(
    '/airroad/jobs/download_labels/',
    data,
    {
      ...requestConfig,
      params,
      responseType: 'blob',
    },
  );
}

export async function postAirroadJobsByIdPrintLabel(
  params: openapi.AirroadPrintLabelQueryOpenapi,
  path: openapi.AirroadPrintLabelPathOpenapi,
  data: openapi.AirroadPrintLabelBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AirroadPrintLabelContentOpenapi> {
  return await api.post<openapi.AirroadPrintLabelContentOpenapi>(
    `/airroad/jobs/${path.id}/print_label/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAirroadJobs(
  params: openapi.AirroadListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AirroadListContentOpenapi> {
  return await api.get<openapi.AirroadListContentOpenapi>(`/airroad/jobs/`, {
    ...requestConfig,
    params,
  });
}

export async function getAirroadJobs2(
  params: openapi.AirroadList2QueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AirroadList2ContentOpenapi> {
  return await api.get<openapi.AirroadList2ContentOpenapi>(`/airroad/jobs-2/`, {
    ...requestConfig,
    params,
  });
}

export async function getAirroadBooking(
  params: openapi.JobsToAirroadListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobsToAirroadListContentOpenapi> {
  return await api.get<openapi.JobsToAirroadListContentOpenapi>(
    `/airroad/booking/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAirroadBooking2(
  params: openapi.JobsToAirroad2ListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobsToAirroad2ListContentOpenapi> {
  return await api.get<openapi.JobsToAirroad2ListContentOpenapi>(
    `/airroad/booking-2/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postAirroadBookingSend(
  params: ReadonlyDeep<openapi.AirroadSingleCreateQueryOpenapi>,
  data: ReadonlyDeep<openapi.AirroadSingleCreateBodyOpenapi>,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): AxiosPromise<openapi.AirroadSingleCreateContentOpenapi> {
  return await api.post<openapi.AirroadSingleCreateContentOpenapi>(
    '/airroad/booking/send/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAirroadJobDetailed(
  params: openapi.AirroadJobDetailedQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AirroadJobDetailedContentOpenapi> {
  return await api.get<openapi.AirroadJobDetailedContentOpenapi>(
    `/airroad/job/detailed/`,
    {
      ...requestConfig,
      params,
    },
  );
}
